import Vue from 'vue'

import Page from './components/home/Page';

export const routes = [

  //Home
  {path: '/', component: Page, name:'home',
    meta: {
      redirectTo: true,
    },
    children: [
      //Dashboard 0
      { title: 'Dashboard', icon: 'bar_chart', path: '/dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ './components/dashboard/Dashboard'),
        name: 'dashboard',
        meta: {
          requiresAuth: true,
        },
      },

      //Artigos 1
      { title: 'Artigos', icon: 'book', path: '/artigos',
        component: () => import(/* webpackChunkName: "articles" */ './components/article/Articles'),
        name: 'articles',
        meta: {
          requiresAuth: true,
        },
      },

      //Fornecedores 2
      { title: 'Fornecedores', icon: 'local_shipping', path: '/fornecedores',
        component: () => import(/* webpackChunkName: "providers" */ './components/provider/Providers'),
        name: 'providers',
        meta: {
          requiresAuth: true,
        }
      },

      //Clientes 3
      { title: 'Clientes', icon: 'person_pin', path: '/clientes',
        component: () => import(/* webpackChunkName: "clients" */ './components/client/Clients'),
        name: 'clients' ,
        meta: {
          requiresAuth: true,
        }
      },

      //Users 4
      { title: 'Funcionários', icon: 'people', path: '/funcionários',
        component: () => import(/* webpackChunkName: "users" */ './components/user/User'),
        name: 'users',
        meta: {
          requiresAuth: true,
        }
      },

      //Companies 5
      { title: 'Empresas', icon: 'corporate_fare', path: '/empresas',
        component: () => import(/* webpackChunkName: "companies" */ './components/company/Companies'),
        name: 'companies',
        meta: {
          requiresAuth: true,
          requiresAdmin: true,
        }
      },

      // Invoice clients 6
      { title: 'Faturas', icon: 'assignment', path: '/facturas',
        component: () => import(/* webpackChunkName: "invoiceClients" */ './components/client/Invoice'),
        name: 'invoiceClients',
        meta: {
          requiresAuth: true,
        }
      },

      //Sells 7
      { title: 'Vendas', icon: 'local_pizza', path: '/vendas',
        component: () => import(/* webpackChunkName: "sells" */ './components/sell/Sells'),
        name: 'sells',
        meta: {
          requiresAuth: true,
        }
      },

      // Purchases 8
      {title: 'Compras', icon: 'local_grocery_store', path: '/compras',
        component: () => import(/* webpackChunkName: "purchases" */ './components/purchase/Purchase'),
        name: 'purchases',
        meta: {
          requiresAuth: true,
        }
      },

      //Budget
      { title: 'Orçamentos', icon: 'card_travel', path: '/orcamento',
        component: () => import(/* webpackChunkName: "budgets" */ './components/budget/Budgets'),
        name: 'budgets',
        meta: {
          requiresAuth: true,
        }
      },

      // Stock
      { title: 'Stock', icon: 'inventory2', path: '/stock',
        component: () => import(/* webpackChunkName: "groupsPermissions" */ './components/stock/Stocks'),
        name: 'stock',
        meta: {
          requiresAuth: true,
        }
      },

      // Groups & Permissions 9
      { title: 'Grupos & Permissões', icon: 'lock', path: '/grupos',
        // component: () => import(/* webpackChunkName: "groupsPermissions" */ './components/group/Group'),
        component: () => import(/* webpackChunkName: "groupsPermissions" */ './components/group_permission/GroupPermission'),
        name: 'groupsPermissions',
        meta: {
          requiresAuth: true,
        }
      },

      // Configurações 10
      { title: 'Configurações', icon: 'settings', path: '/settings',
        component: () => import(/* webpackChunkName: "settings" */ './components/settings/setting'),
        name: 'settings',
        meta: {
          requiresAuth: true,
        }
      },

    ]
  },

  // Login
  {title: 'Login', path: '/login',
    component: () => import(/* webpackChunkName: "login" */ './components/home/Login'),
    name: 'login',
    meta: {
      requiresAuth: false,
      isLogin: true,
      // requiresVisitor: true,
    }
  },

  // Forgot password
  {title: 'EsqueciMinhaSenha', path: '/reset-password',
    component: () => import(/* webpackChunkName: "reset-password" */ './components/password_reset/PasswordReset'),
    name: 'reset-password',
    meta: {
      requiresAuth: false,
      isForgotPass: true,
    }
  },

  //Any other path (redirect)
  // { path: '/*', redirect: { name: 'home' }},
];
